// Texte der Oberfläche für Textbausteine, Verbrauch, Kontaktregeln und Funktionsschalter (Runde 8, Agent 8D).
// Eigene Datei im eigenen Ordner, nicht in `texte.ts` (Fundament).

export const T8D = {
  slash: {
    titel: "Textbausteine",
    keine: "Noch keine Textbausteine. Lege sie unter Einstellungen › Textbausteine an.",
    keinTreffer: "Kein Textbaustein passt.",
  },

  bausteine: {
    einleitung:
      "Ein Textbaustein ist ein kurzer, fertiger Text. Tippe in E-Mail, SMS oder Notiz einen Schrägstrich und die ersten Buchstaben des Kürzels, wähle ihn mit Enter, und der Text steht an der Stelle des Cursors. Platzhalter wie {{ contact.first_name }} werden beim Senden ersetzt.",
    suchen: "Suchen …",
    alleKanaele: "Alle Kanäle",
    neu: "Neuer Textbaustein",
    leer: "Noch keine Textbausteine.",
    leerSuche: "Kein Textbaustein passt zur Suche.",
    kuerzel: "Kürzel",
    kuerzelHilfe: "Das tippst du nach dem Schrägstrich. Buchstaben, Ziffern, Punkt, Bindestrich und Unterstrich.",
    name: "Name",
    kanal: "Wo er angeboten wird",
    kanalSpalte: "Kanal",
    inhalt: "Text",
    nutzungen: "Benutzt",
    teilen: "Mit dem Team teilen",
    teilenHilfe: "Alle sehen und benutzen ihn. Ändern darf ihn nur, wer die Team-Vorlagen verwalten darf.",
    teilenGesperrt: "Geteilte Textbausteine legt nur an, wer die Team-Vorlagen verwalten darf.",
    privat: "Privat",
    geteilt: "Geteilt",
    von: (name: string | null | undefined) => (name ? `von ${name}` : "vom Team"),
    bearbeiten: "Bearbeiten",
    loeschen: "Löschen",
    loeschenFrage: (kuerzel: string) => `Textbaustein „/${kuerzel}“ wirklich löschen?`,
    speichern: "Speichern",
    abbrechen: "Abbrechen",
    gespeichert: "Textbaustein gespeichert.",
    geloescht: "Textbaustein gelöscht.",
    smsHinweis: "Eine SMS ist Klartext. Platzhalter wie {{ contact.first_name }} gehen.",
    smsZeichen: (n: number) => `${n} von 1.000 Zeichen`,
    kanaele: { alle: "E-Mail, SMS und Notiz", email: "Nur E-Mail", sms: "Nur SMS", notiz: "Nur Notiz" } as Record<string, string>,
    kanalKurz: { alle: "Alle", email: "E-Mail", sms: "SMS", notiz: "Notiz" } as Record<string, string>,
    kuerzelFehlt: "Das Kürzel fehlt.",
    nameFehlt: "Der Name fehlt.",
    textFehlt: "Der Text ist leer.",
    smsNote: "Die SMS-Vorlagen mit Variablen bleiben unter Einstellungen › Vorlagen. Textbausteine ergänzen sie mit einem Kürzel.",
  },

  verbrauch: {
    einleitung:
      "Was die Telefonie dieses Monats bei Twilio kostet. Das CRM fragt Twilio nur lesend und alle sechs Stunden. Aufgeladen oder bezahlt wird hier nie etwas.",
    monat: "Monat",
    aktualisieren: "Jetzt abfragen",
    aktualisiert: "Verbrauch bei Twilio abgefragt.",
    abgerufen: (wann: string) => `Stand: ${wann}`,
    nochNie: "Noch nicht abgefragt.",
    keinZugang: "Der Twilio-Zugang ist nicht eingerichtet. Ohne ihn gibt es keine Zahlen. Trage ihn unter Einstellungen › Telefonie ein.",
    keineDaten: "Für diesen Monat liegen noch keine Zahlen vor. „Jetzt abfragen“ holt sie bei Twilio.",
    posten: "Posten",
    menge: "Menge",
    betrag: "Kosten",
    summe: "Summe",
    postenNamen: {
      anrufe_ausgehend: "Ausgehende Anrufe",
      anrufe_eingehend: "Eingehende Anrufe",
      sms: "SMS",
      nummern: "Rufnummern",
      sonstiges: "Sonstiges",
    } as Record<string, string>,
    einheiten: { min: "Min.", stueck: "Stück" } as Record<string, string>,
    limit: "Monatslimit",
    limitHilfe: "Eine Grenze für die Kosten eines Monats. Das CRM sperrt nichts, es warnt nur: hier und per Push aufs Handy.",
    limitLeer: "Kein Limit",
    warnenAb: "Warnen ab (%)",
    warnenAbEinheit: "% des Limits",
    prozentEinheit: "%",
    kurs: "Kurs Dollar in Euro",
    kursHilfe: "Nur wenn Twilio in US-Dollar abrechnet und du die Zahlen in Euro sehen willst. Leer lassen zeigt die Beträge in der Währung des Kontos.",
    limitSpeichern: "Limit speichern",
    limitGespeichert: "Limit gespeichert.",
    warnungSchwelle: (prozent: number) => `Die Kosten haben ${prozent.toLocaleString("de-DE", { maximumFractionDigits: 0 })} % des Monatslimits erreicht.`,
    warnungLimit: "Das Monatslimit ist erreicht.",
    verlauf: "Die letzten Monate",
    verlaufLeer: "Noch keine abgeschlossenen Monate abgefragt.",
    prozentVon: (p: number, limit: string) => `${p.toLocaleString("de-DE", { maximumFractionDigits: 0 })} % von ${limit}`,
  },

  regeln: {
    einleitung:
      "Diese Regeln gelten für jeden Anruf aus dem CRM und für den Power Dialer. Du kannst sie nur strenger machen als die gesetzliche Linie, nie lockerer.",
    waehlzeit: "Wählzeit",
    von: "Von",
    bis: "Bis",
    waehlzeitHilfe: (von: string, bis: string) => `Frühestens ${von} Uhr, spätestens bis ${bis} Uhr.`,
    tage: "Angerufen wird am",
    tageHilfe: "Sonntage und Feiertage sind immer gesperrt.",
    tagKurz: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
    tagLang: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
    feiertage: "Feiertage",
    feiertageText: "Gesperrt (immer). Es gelten die Feiertage in Baden-Württemberg und dazu die der Organisation.",
    organisationLink: "Einstellungen › Organisation",
    versuche: "Versuche je Lead und Tag",
    versucheHilfe: (max: number) => `Höchstens ${max}. Gilt derzeit nicht: der Power Dialer wählt weiter und der Einzelanruf fragt nicht nach.`,
    klingeldauer: "Mindestklingeldauer",
    klingeldauerHilfe: (min: number) => `Mindestens ${min} Sekunden. Kürzere Anrufe wirken wie Ping-Anrufe.`,
    sekunden: "Sekunden",
    wiederwahl: "Wiederwahlsperre",
    wiederwahlHilfe: (min: number) => `Nach einem Aufbaufehler auf dieselbe Nummer frühestens nach so vielen Minuten wieder wählen (mindestens ${min}).`,
    minuten: "Minuten",
    speichern: "Speichern",
    gespeichert: "Kontaktregeln gespeichert.",
    standard: "Auf Standard zurücksetzen",
    sperrtage: "Die nächsten gesperrten Tage",
    sperrtagOrg: "laut Organisation",
    jetzt: "Jetzt",
    jetztErlaubt: "Anrufen ist jetzt erlaubt.",
    jetztGesperrt: (meldung: string) => meldung,
    grenzenTitel: "Die feste Linie",
    grenzenText:
      "Diese Regeln bremsen das Anrufen derzeit nicht (18.10.2026). Frühere Compliance-Linie „keine Grauzonen“ vom 08.10.2026: Montag bis Samstag, 8 bis 20 Uhr, keine Feiertage, höchstens 3 Versuche je Lead und Tag, nur Deutschland, Österreich und die Schweiz, kein Notruf. Darunter lässt sich nichts einstellen.",
    umgebung: "Der Server ist strenger eingestellt",
  },

  schalter: {
    einleitung:
      "Funktionen, bei denen eine Rechtsfrage offen ist, stehen auf „aus“. Hier siehst du, warum, und wer sie wann freigegeben hat. Der Schalter hält die Freigabe fest. Er hebt keine Sperre in den Wegen auf: Kalt-Mail-Schutz, Wählzeiten, Werbesperre und Abmeldungen gelten immer.",
    keinWegLiest:
      "Heute liest noch kein Weg im CRM diese Schalter. Sie halten die Freigabe und ihre Begründung fest; sobald ein Weg einen Schalter berücksichtigt, steht das hier an der Funktion.",
    status: { frei: "Frei", nach_freigabe: "Nur nach Freigabe", bewusst_aus: "Bewusst nicht gebaut" } as Record<string, string>,
    an: "An",
    aus: "Aus",
    einschalten: "Einschalten",
    ausschalten: "Ausschalten",
    nichtSchaltbar: "Lässt sich nicht einschalten",
    freigegeben: (wer: string | null | undefined, wann: string) => `Freigegeben${wer ? ` von ${wer}` : ""} am ${wann}`,
    dialogTitel: (titel: string) => `„${titel}“ einschalten`,
    dialogText: "Das CRM ist keine Rechtsberatung. Schalte nur ein, wenn die Rechtsfrage geklärt ist. Person, Datum und Begründung stehen danach im Freigabeprotokoll.",
    begruendung: "Begründung",
    begruendungHilfe: "Zum Beispiel: Antwort des Anwalts vom Datum, Einwilligung liegt vor.",
    begruendungZuKurz: "Bitte eine Begründung mit mindestens 8 Zeichen eintragen.",
    bestaetigung: "Ich habe die Rechtslage geprüft.",
    eingeschaltet: "Funktion eingeschaltet.",
    ausgeschaltet: "Funktion ausgeschaltet.",
    protokoll: "Freigabeprotokoll",
    protokollLeer: "Noch nichts umgelegt.",
    protokollAn: "eingeschaltet",
    protokollAus: "ausgeschaltet",
    angebunden: "Wirkt heute",
    abbrechen: "Abbrechen",
  },

  backoffice: {
    titel: "Backoffice öffnen",
  },
} as const;
